import { Component } from '@angular/core';
import { AuthMethod } from '@app/shared/models/auth-method';
import { NgClass } from '@angular/common';
import { SessionService } from '@services/session.service';
import { ActivatedRoute } from '@angular/router';
import { combineLatest } from 'rxjs';

@Component({
  selector: 'app-login',
  imports: [NgClass],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent {
  private redirectUrl = '/buildings';
  private alreadyHandledAuthError = false;
  loginMethods: AuthMethod[] = [AuthMethod.AUTH0];

  constructor(private readonly route: ActivatedRoute, private readonly sessionService: SessionService) {
    combineLatest([this.route.queryParams]).subscribe(([params]) => {
      this.redirectUrl = params.redirectUrl;
      this.authenticate();
    });
  }

  public authenticate(): void {
    if (this.redirectUrl) {
      this.sessionService.authenticate(this.redirectUrl);
    } else {
      this.sessionService.authenticate();
    }
  }

  public getLoginButtonClass(): string {
    return 'or-icon-or';
  }

  public getLoginButtonLabel(): string {
    return 'Custom authentication';
  }
}
